import axios from "axios";
// In development, proxy handles routing to Django
// In production, both frontend and backend are served from same origin
const API_BASE_URL = process.env.NODE_ENV === "development" ? "/api" : "/api";
export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});
// Request interceptor
apiClient.interceptors.request.use((config) => {
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Response interceptor
apiClient.interceptors.response.use((response) => response, (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
});
